
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 3H5a2 2 0 0 0-2 2v3"}}),_c('path',{attrs:{"d":"M21 8V5a2 2 0 0 0-2-2h-3"}}),_c('path',{attrs:{"d":"M3 16v3a2 2 0 0 0 2 2h3"}}),_c('path',{attrs:{"d":"M16 21h3a2 2 0 0 0 2-2v-3"}})])
          )
        }
      }
    